// extracted by mini-css-extract-plugin
export var bg = "fastReg-module--bg--B6ms+";
export var container = "fastReg-module--container--e0cL1";
export var desc = "fastReg-module--desc--eOWmA";
export var h_char = "fastReg-module--h_char--iXWUK";
export var head = "fastReg-module--head--CxlZO";
export var root = "fastReg-module--root---nP2K";